const jQuery = require('jquery')
window.jQuery = window.$ = window.jquery = jQuery
